import { createReducer } from '@reduxjs/toolkit';
import { PAGE_SIZE } from 'constants/ui';

import { LOCATION_FILTER } from 'constants/location';
import { DEFAULT_SORT_CONFIG } from 'constants/sort';
import * as actions from './actions';

export const initialState = {
  employees: {
    data: {},
    sortIds: [],
    isLoading: false,
    isLoadingCreate: false,
    isLoadingChange: false,
    isLoadingResendInvite: false,
  },
  roles: {
    data: [],
    isLoading: false,
  },
  fetchParams: {
    pagination: {
      page: 0,
      size: PAGE_SIZE,
      count: 0,
    },
    sort: DEFAULT_SORT_CONFIG,
    location: LOCATION_FILTER.ALL,
    search: '',
    isLoading: false,
    showDeletedEmployees: false,
  },
};

export const employeesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.getEmployeeList.start, (state, action) => {
      const { filter, isClearPage } = action?.payload || {};

      return {
        ...state,
        employees: {
          ...state.employees,
          isLoading: true,
        },
        fetchParams: {
          ...state.fetchParams,
          pagination: {
            ...state.fetchParams.pagination,
            page: isClearPage ? 0 : state.fetchParams.pagination.page,
          },
          isLoading: !!filter,
        },
      };
    })
    .addCase(actions.getEmployeeList.success, (state, action) => {
      const { data, ids, page, count } = action.payload;

      return {
        ...state,
        employees: {
          ...state.employees,
          data,
          sortIds: ids,
          isLoading: false,
        },
        fetchParams: {
          ...state.fetchParams,
          pagination: {
            ...state.fetchParams.pagination,
            page,
            count,
          },
          isLoading: false,
        },
      };
    })
    .addCase(actions.getEmployeeList.failure, (state) => ({
      ...state,
      employees: {
        ...state.employees,
        isLoading: false,
      },
      fetchParams: {
        ...state.fetchParams,
        isLoading: false,
      },
    }))
    .addCase(actions.createEmployee.start, (state) => ({
      ...state,
      employees: {
        ...state.employees,
        isLoadingCreate: true,
      },
    }))
    .addCase(actions.createEmployee.success, (state) => {
      return {
        ...state,
        employees: {
          ...state.employees,
          isLoadingCreate: false,
        },
      };
    })
    .addCase(actions.createEmployee.failure, (state) => ({
      ...state,
      employees: {
        ...state.employees,
        isLoadingCreate: false,
      },
    }))
    .addCase(actions.changeEmployee.start, (state) => ({
      ...state,
      employees: {
        ...state.employees,
        isLoadingChange: true,
      },
    }))
    .addCase(actions.changeEmployee.success, (state) => {
      return {
        ...state,
        employees: {
          ...state.employees,
          isLoadingChange: false,
        },
      };
    })
    .addCase(actions.changeEmployee.failure, (state) => ({
      ...state,
      employees: {
        ...state.employees,
        isLoadingChange: false,
      },
    }))
    .addCase(actions.removeEmployee.start, (state) => ({
      ...state,
      employees: {
        ...state.employees,
        isLoading: true,
      },
    }))
    .addCase(actions.removeEmployee.success, (state) => {
      return {
        ...state,
        employees: {
          ...state.employees,
          isLoading: false,
        },
      };
    })
    .addCase(actions.removeEmployee.failure, (state) => ({
      ...state,
      employees: {
        ...state.employees,
        isLoading: false,
      },
    }))
    .addCase(actions.getUserRoles.start, (state) => ({
      ...state,
      roles: {
        ...state.roles,
        isLoading: true,
      },
    }))
    .addCase(actions.getUserRoles.success, (state, action) => {
      const roles = action.payload;
      return {
        ...state,
        roles: {
          ...state.roles,
          data: roles,
          isLoading: false,
        },
      };
    })
    .addCase(actions.getUserRoles.failure, (state) => ({
      ...state,
      roles: {
        ...state.roles,
        isLoading: false,
      },
    }))
    .addCase(actions.changeFilterSearch, (state, action) => {
      const currentValue = action.payload;
      return {
        ...state,
        fetchParams: {
          ...state.fetchParams,
          pagination: {
            ...state.fetchParams.pagination,
          },
          search: currentValue,
        },
      };
    })
    .addCase(actions.changePage, (state, action) => {
      const page = action.payload;
      return {
        ...state,
        fetchParams: {
          ...state.fetchParams,
          pagination: {
            ...state.fetchParams.pagination,
            page,
          },
        },
      };
    })
    .addCase(actions.changeLocation, (state, action) => {
      const value = action.payload || LOCATION_FILTER.ALL;
      return {
        ...state,
        fetchParams: {
          ...state.fetchParams,
          location: value,
        },
      };
    })
    .addCase(actions.changeSort, (state, action) => {
      const value = action.payload || DEFAULT_SORT_CONFIG;

      return {
        ...state,
        fetchParams: {
          ...state.fetchParams,
          sort: value,
        },
      };
    })
    .addCase(actions.changeShowDeletedEmployees, (state, action) => {
      const value = action.payload;
      return {
        ...state,
        fetchParams: {
          ...state.fetchParams,
          showDeletedEmployees: value,
        },
      };
    });
});
